import React from 'react';
import { motion } from 'framer-motion';
import * as SiIcons from 'react-icons/si';
import SafeIcon from '../common/SafeIcon';

const { SiTiktok } = SiIcons;

const Footer = () => {
  return (
    <motion.footer 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-8 mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-6">
          <div className="flex flex-wrap items-center justify-center gap-2 text-center">
            {/* Logo PlaPi con su degradado original */}
            <span className="text-lg font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              PlaPi
            </span>

            {/* Pleca separadora */}
            <span className="text-gray-400 dark:text-gray-600 font-light mx-1">|</span>

            {/* Mención a Appfred con su degradado específico Blue-600 a Cyan-500 */}
            <span className="text-gray-600 dark:text-gray-400 font-medium">
              Una aplicación de{' '}
              <a 
                href="https://appfred.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
              >
                Appfred
              </a>
            </span>

            {/* Copyright y Autor */}
            <span className="text-gray-500 dark:text-gray-500 ml-2">
              © 2026, Alfredo Menéndez
            </span>
          </div>

          {/* Icono de TikTok solitario */}
          <motion.a 
            href="https://www.tiktok.com/@alfredmenendez" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors duration-200"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={SiTiktok} className="w-6 h-6" />
          </motion.a>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;